import { ResponsivenessManager } from '@/game/GameComponents/PhaserGame/Managers/ResponsivenessManager';
import Login from '@/game/scenes/Login/Login';

export class PhaserLoginForm {
  constructor(private scene: Phaser.Scene) {
    // Make the login forms in the scene.
    // Styling.
    scene.add.dom(0, 0).createFromHTML(`<style>
        
                 .login-form {
                    display: flex;
                    flex-direction: column;
                    gap: 16px;
                  }
                  #login-form-m {
                    gap: 8px;
                  }
                  .login-input {
                    background-color: #ebcba8;
                    color: #52333f;
                    text-align: center;
                    font-family: 'Aronui';
                    font-style: bold;
                  }
                  .login-input-d {
                    width: 348px;
                    height: 48px;
                    font-size: 20px;
                    border-radius: 24px;
                  }
                  .login-input-m {
                    width: 192px;
                    height: 48px;
                    font-size: 14px;
                    border-radius: 24px;
                  }
                  .login-input::placeholder {
                    color: #52333f;
                  }
                 .password-wrapper {
                    position: relative;
                    display: flex;
                    align-items: center;
                  }
                  .password-wrapper .login-input {
                    box-sizing: border-box;
                  }
                  .password-toggle {
                    position: absolute;
                    right: 12px;
                    top: 50%;
                    transform: translateY(-50%);
                    background: none;
                    border: none;
                    padding: 0;
                    cursor: pointer;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                  }
                  .password-toggle img {
                    width: 28px;
                    height: 28px;
                    object-fit: contain;
                  }
                </style>`);

    // Create the desktop login form.
    this.loginForm_d = scene.add.dom(400, 420).createFromHTML(`
                <form id="login-form-d" class="login-form">
                  <button type="submit" style="display:none">Login</button>
                  <input id="username-input-d" type="text" class="login-input login-input-d" placeholder="Enter Username"></input>
                  <div class="password-wrapper">
                    <input id="password-input-d" type="password" class="login-input login-input-d password-input" placeholder="Enter Password"></input>
                    <button type="button" class="password-toggle">
                      <img id="password-toggle-icon-d" class="password-toggle-icon" src="game_assets/sprites/phaser_game/phaser_game_ui/login/password_show.png" alt="Show password">
                    </button>
                  </div>

                </form>`);

    // Create the mobile login form.
    this.loginForm_m = scene.add.dom(493, 136).createFromHTML(`
                <form id="login-form-m" class="login-form">
                  <button type="submit" style="display:none">Login</button>
                  <input id="username-input-m" type="text" class="login-input login-input-m" placeholder="Enter Username"></input>
                  <div class="password-wrapper">
                    <input id="password-input-m" type="password" class="login-input login-input-m password-input" placeholder="Enter Password"></input>
                    <button type="button" class="password-toggle">
                      <img id="password-toggle-icon-m" class="password-toggle-icon" src="game_assets/sprites/phaser_game/phaser_game_ui/login/password_show.png" alt="Show password">
                    </button>
                  </div>

                </form>`);

    // Desktop password toggle.
    this.passwordToggleQuerySelection_d = this.loginForm_d.node.querySelector(
      '#password-toggle-icon-d',
    );
    this.passwordToggleQuerySelection_d?.addEventListener(
      'click',
      this.handlePasswordToggleClicked.bind(this),
    );

    // Mobile password toggle.
    this.passwordToggleQuerySelection_m = this.loginForm_m.node.querySelector(
      '#password-toggle-icon-m',
    );
    this.passwordToggleQuerySelection_m?.addEventListener(
      'click',
      this.handlePasswordToggleClicked.bind(this),
    );

    const form_d = this.loginForm_d.node.querySelector('#login-form-d');
    const form_m = this.loginForm_m.node.querySelector('#login-form-m');

    form_d?.addEventListener('submit', (e) => {
      e.preventDefault();
      this.handleLoginSubmitted?.();
    });

    form_m?.addEventListener('submit', (e) => {
      e.preventDefault();
      this.handleLoginSubmitted?.();
    });
  }

  loginForm_d: Phaser.GameObjects.DOMElement;
  loginForm_m: Phaser.GameObjects.DOMElement;
  private passwordToggleQuerySelection_d?: Element | null;
  private passwordToggleQuerySelection_m?: Element | null;

  public handleLoginSubmitted?: () => void;

  getUsernameInput(): string {
    if (ResponsivenessManager.IsMobileDevice(this.scene)) {
      const mobileInput =
        this.loginForm_m.node.querySelector<HTMLInputElement>(
          '#username-input-m',
        );
      return mobileInput?.value || '';
    } else {
      const desktopInput =
        this.loginForm_d.node.querySelector<HTMLInputElement>(
          '#username-input-d',
        );
      return desktopInput?.value || '';
    }
  }

  getPasswordInput(): string {
    if (ResponsivenessManager.IsMobileDevice(this.scene)) {
      const mobileInput =
        this.loginForm_m.node.querySelector<HTMLInputElement>(
          '#password-input-m',
        );
      return mobileInput?.value || '';
    } else {
      const desktopInput =
        this.loginForm_d.node.querySelector<HTMLInputElement>(
          '#password-input-d',
        );
      return desktopInput?.value || '';
    }
  }

  update() {
    // Todo: reimplement this if we reintroduce the orientation modal.
    // const currentDimensionRatio = ResponsivenessManager.GetDeviceOrientation(
    //   this.scene,
    // );
    // const isMobile = ResponsivenessManager.IsMobileDevice(this.scene);
    // if (isMobile && currentDimensionRatio === 'landscape') {
    //   this.loginForm_m.setVisible(false);
    // }
  }

  handleResize() {
    // Desktop form.
    const login = this.scene as Login;
    if (!login || !login.scene.isActive()) return;
    const parentPos = { x: login.mainContainer.x, y: login.mainContainer.y };
    const inputPos = {
      x: parentPos.x + login.inputPlaceholder_username.x,
      y: parentPos.y + login.inputPlaceholder_username.y,
    };
    this.loginForm_d.setOrigin(0, 0.5);
    this.loginForm_d.setPosition(inputPos.x, inputPos.y);

    // Mobile form.
    const mobileContainerPos = {
      x: login.mainContainer_m.x,
      y: login.mainContainer_m.y,
    };
    const inputViewPos = {
      x: mobileContainerPos.x + login.inputView_m.x,
      y: mobileContainerPos.y + login.inputView_m.y,
    };
    const pos = {
      x: inputViewPos.x + login.inputPlaceholdersContainer.x,
      y: inputViewPos.y + login.inputPlaceholdersContainer.y,
    };

    this.loginForm_m.setOrigin(0, 0);
    this.loginForm_m.setPosition(pos.x, pos.y);
  }

  handlePasswordToggleClicked = () => {
    [this.loginForm_d, this.loginForm_m].forEach((form) => {
      const passwordToggleIcon = form.node.querySelector(
        '.password-toggle-icon',
      ) as HTMLImageElement | null;

      const passwordInput = form.node.querySelector(
        '.password-input',
      ) as HTMLInputElement | null;

      if (!passwordInput || !passwordToggleIcon) return;
      const isHidden = passwordInput.type === 'password';
      passwordInput.type = isHidden ? 'text' : 'password';
      passwordToggleIcon.src = isHidden
        ? 'game_assets/sprites/phaser_game/phaser_game_ui/login/password_hide.png'
        : 'game_assets/sprites/phaser_game/phaser_game_ui/login/password_show.png';
      passwordToggleIcon.alt = isHidden ? 'Hide password' : 'Show password';
    });
  };
}
